import React, { useCallback, useContext } from 'react';
import emoji from 'node-emoji';
import { CardView, SettingsItemNavigate, rem } from 'design-system';
import Section from 'design-system/Section';
import IconTransactionCategory from 'features/transactions/icons/IconTransactionCategory';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import Alert from 'utils/packages/Alert';
import Modal from 'utils/packages/Modal';
import { WalkthroughContext } from 'features/feed/components/walkthrough/context';
import { styles } from './styles';
const TransactionCategorySection = ({ transaction, onCategoryEdit, }) => {
    const navigation = useMainStackNavigation();
    const isInWalkthrough = useContext(WalkthroughContext);
    const editCategory = useCallback(() => {
        navigation.navigateDeprecated('EditCategory', {
            category: transaction.category,
            transaction,
            onEditCallBack: onCategoryEdit,
        });
    }, [transaction, onCategoryEdit]);
    const openEdit = useCallback(() => {
        if (transaction.isPending) {
            Alert.alert(emoji.emojify('Hold on :dizzy:'), 'Pending transactions like to change, so we can’t edit them yet. Don’t worry, they don’t count in Analytics.');
            return;
        }
        if (transaction.category?.id === 'internal' ||
            transaction.category?.id === 'transfer') {
            Modal.showConfirmation({
                title: transaction.category.id === 'internal' ? 'Excluded' : 'Transfer',
                subtitle: transaction.category.id === 'internal'
                    ? 'Your credit repayments and any transactions you don’t want to count in Analytics or Budgeting should always stay here.'
                    : 'Your internal transfers should always stay here, otherwise your income and expenses will count twice in Budgeting and Analytics.',
                confirmButtonTitle: 'Thanks, I’ll keep it here',
                cancelButtonTitle: 'Okay, but let me edit!',
                onPressCancel: editCategory,
            });
            return;
        }
        editCategory();
    }, [editCategory, transaction.category?.id, transaction.isPending]);
    return (<Section style={styles.categorySection}>
      <CardView noMarginTop noMarginBottom webPadding noMargin={isInWalkthrough}>
        <SettingsItemNavigate titleFirst disabled={transaction.isPending} icon={<IconTransactionCategory width={rem(24)} height={rem(24)} category={transaction.category}/>} title={transaction.category?.displayName} description={transaction.isPending ? null : 'Change category'} onPress={openEdit}/>
      </CardView>
    </Section>);
};
export default TransactionCategorySection;
